import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import AmountBetslipForm from './AmountBetslipForm';
import BetslipButtons from './BetslipButtons';
import EventCoupon from './EventCoupon';
import PotentialWinBox from './PotentialWinBox';
import { playableInMultiple } from '../../data/purchase-service';
import EventCouponWh from './betslip-components-wh/EventCouponWh';
import { getConfiguration } from '../../data/utils';

function MultiBets(props) {
	const betslipContext = useContext(BetslipContext);
	const conf = getConfiguration();
	let betslipData = betslipContext.getBetslipData();
	const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const showable = props.showable;
    const container = "multibets";
    const reactKeyPWB = 'key-potential-win-box-coupon-' + couponKey + '-container-' + container;
    const reactKeyButtons = 'key-betslip-buttons-' + couponKey + '-container-' + container;
    
    let selections = coupon.selections;
    
    // restoring the selections array for the draw
    let restoredSelections = [];
    for(let k in selections){
		let selection = selections[k];
		const playableInMulti = playableInMultiple(selection.bets);
    	if(betslipContext.isBetBuilder()){
    		// pushing it with all its bets: it will showed as a system
    		selection = JSON.parse(JSON.stringify(selection));
    		restoredSelections.push(selection);
    	}
    	else{
	    	if(selection.bets.length === 1){
	    		// duplicate object
	    		selection = JSON.parse(JSON.stringify(selection));
	    		restoredSelections.push(selection);
	    	}
	    	else{
	    		for(let km = 0; km < selection.bets.length; km ++){
	    			let bet = selection.bets[km];
	    			// km == 0; it is the first bet choosed: I've to render it in anycase
	    			// playableInMulti = true, it means that this draw can be rendered in multibets everytime, also if it is sharing
	    			// the pal.avv with another draw selected before.
	    			if(km == 0 || playableInMulti){
	    				let duplicatedSelection  = JSON.parse(JSON.stringify(selection));
	    				duplicatedSelection.bets = [];
	        			duplicatedSelection.bets.push(bet);
	        			restoredSelections.push(duplicatedSelection);			
	    			}
	    		}
	    	}
    	}
    }
    
    return (
	<div className={"tab-pane fade bordato-widget" + (showable? ' show active' : '')} 
	     id={"container-" + container + "-coupon-" + couponKey} role="tabpanel">
		<div className="carrello-scrollable">	
			<div className="lista-eventi-schedina carrello-desktop_container-elementi">
			{
				restoredSelections.map(function(selection){
					// always the first bet is taken: if the bet is "legabile", then I will face a duplicated event in the next selection
					let betKey = selection.bets[0].scomSogei + "_" + selection.bets[0].handicap + "-draw-" + selection.bets[0].draw;
					let reactKey = "key-bet-event-coupon-" + couponKey + "-container-" + container + "-pal-" + selection.pal + "-avv-" + selection.avv + "-for-bet-" + betKey;
					return <React.Fragment key={reactKey}>
					{
	            		conf.iwh?
	            		<EventCouponWh selection={selection} couponKey={couponKey} container={container} />
	            		:      		
						<EventCoupon selection={selection} couponKey={couponKey} container={container} />
					}
					</React.Fragment>
					
				})	
			}
			</div>
		</div>
		<div className="carrello-fixed">
			<AmountBetslipForm container={container} linkedElement={"bet-coupon-" + couponKey + "-container-" + container} isEventForm={false} couponKey={couponKey} />
			<PotentialWinBox container={container} couponKey={couponKey} key={reactKeyPWB} />
			<BetslipButtons container={container} couponKey={couponKey} key={reactKeyButtons} />
		</div>
	</div>
    );
}

export default MultiBets;